import { render, staticRenderFns } from "./ConstructManage.vue?vue&type=template&id=17b5b66d&"
import script from "./ConstructManage.vue?vue&type=script&lang=js&"
export * from "./ConstructManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports